import React from "react";
import { UserType } from "#/api/oidc/oidcConfig";
import { useOidcUser } from "@axa-fr/react-oidc";
import { Button, Icon } from "@sicredi/react";
import styles from "./styles.module.scss";
import getFirstName from "#/utils/getFirstName";

export default function RedirectAccount() {
  const { oidcUser } = useOidcUser<UserType>();

  return (
    <div
      className={styles["button-area"]}
      onClick={() => {
        window.open(
          "https://shopping.sicredi.com.br/account#/",
          "_blank",
          "noopener, noreferrer"
        );
      }}
    >
      <div className={styles["button-login"]}>
        <Button className={styles["button-icon"]}>
          <Icon size={16} name="user" color={"#3FA111"} />
        </Button>
        <div className={styles["login-text"]} style={{ width: "85%" }}>
          <div className={styles["welcome"]}>
            <div className={styles["usergreeting"]}>
              Olá, {getFirstName(oidcUser?.name)}
            </div>
          </div>
        </div>
        <div className={styles["chevroncontainer"]} style={{ width: "15%" }}>
          <Icon
            name="chevron-right"
            appearance="primary"
            data-testid="button-logout"
            className={styles["chevronicon"]}
          />
        </div>
      </div>
    </div>
  );
}
